import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../i18n';

const LanguageContext = createContext();

const applyToDoc = (code) => {
  document.documentElement.setAttribute('lang', code);
  document.documentElement.setAttribute('dir', code === 'ar' ? 'rtl' : 'ltr');
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem('lang');
    return stored === 'ar' ? 'ar' : 'en';
  });

  useEffect(() => {
    applyToDoc(lang);
    i18n.changeLanguage(lang);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setLang = (code) => {
    setLangState(code);
    i18n.changeLanguage(code);
    localStorage.setItem('lang', code);
    applyToDoc(code);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
